import { ActionReducerMap } from '@ngrx/store';
import { AddOnAppState as State } from './add-ons-state';

export const AddOnReducers: ActionReducerMap<State> = {
};
